/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
var DiscountHandlerManager = (function () {

    var loadHandlerForm = function(handlerCode) {

        var handlerContainer = $('#discount_handler_container');

        $.ajax({
            url: '/shop/discounts/handlers/' + handlerCode,
            type: 'GET',
            dataType: 'html',

            success: function (data) {

                handlerContainer.fadeOut('fast', function() {
                    handlerContainer.html(data);
                    handlerContainer.fadeIn('fast');
                });
            }
        });
    };

    var init = function () {

        $('input[name=class]:enabled').change(function() {
            loadHandlerForm($(this).val());
        });
    };

    return {
        init: init
    };

})();

export default DiscountHandlerManager;
